import { Badge, Tooltip, Text } from "@mantine/core"
import {
  IconAlertTriangle,
  IconChecks,
  IconHourglass,
} from "@tabler/icons-react"
import { useMemo } from "react"

import { ExportRequestDtoStatus } from "~/gen/api"

export const ExportStatusColorEnum: {
  [key in ExportRequestDtoStatus]: string
} = {
  PENDING: "var(--mantine-color-yellow-5)",
  IN_PROGRESS: "var(--mantine-color-blue-5)",
  SUCCESS: "var(--mantine-color-green-6)",
  ERROR: "var(--mantine-color-error)",
  FAILED: "var(--mantine-color-error)",
}

export function getStatusColor(status: ExportRequestDtoStatus): string {
  return ExportStatusColorEnum[status] ?? "var(--mantine-color-gray-6)"
}

export function ExportStatusBadge({
  status,
}: {
  status: ExportRequestDtoStatus
}) {
  const statusIcons = useMemo<{
    [key in ExportRequestDtoStatus | "default"]: React.ReactNode
  }>(
    () => ({
      PENDING: <IconHourglass />,
      ERROR: <IconAlertTriangle />,
      FAILED: <IconAlertTriangle />,
      IN_PROGRESS: <IconHourglass />,
      SUCCESS: <IconChecks />,
      default: null,
    }),
    []
  )

  const color = getStatusColor(status)

  const icon = useMemo(
    () => statusIcons[status] ?? statusIcons.default,
    [status, statusIcons]
  )

  return (
    <Tooltip label={status}>
      <Badge size="lg" leftSection={icon} color={color} autoContrast>
        <Text fw="bold">{status}</Text>
      </Badge>
    </Tooltip>
  )
}
